import styled from "@emotion/styled";
import { SelectedLayersType } from "../../types/dataTypes";
import { COLORS_BASE } from "../../utils/consts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SvgIcon } from "../../styles/styles";
import Circle from "../Shared/Circle";

type LegendProps = {
  isRemoving: boolean;
  layer: SelectedLayersType;
};

function LegendItem({ isRemoving, layer }: LegendProps) {
  return (
    <IconTextContainerLegend isRemoving={isRemoving}>
      <AnimatedIcon isRemoving={isRemoving}>
        {layer.type === 'marker' && layer.icon && (
          typeof layer.icon === 'string' ? (
            <SvgIcon src={layer.icon} width="25px" height="25px"/>
          ) : (
            <IconWrapper>
              <FontAwesomeIcon icon={layer.icon} />
            </IconWrapper>
          )
        )}
        {layer.type === 'line' && <Line color={layer.colour == undefined ? '' : layer.colour} /> }
        {layer.type === 'circle' && <Circle color={layer.colour == undefined ? '' : layer.colour} borderColor={layer.borderColor === undefined ? '' : layer.borderColor} width="10"/> } 
      </AnimatedIcon>
      {layer.layerName}
    </IconTextContainerLegend>
  );
}

const IconTextContainerLegend = styled.div<{ isRemoving: boolean }>`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px;
  font-size: 14px;
  transition: opacity 0.5s ease-out, transform 0.5s ease-out; /* Add transition for smooth removal */
  opacity: ${({ isRemoving }) => (isRemoving ? 0 : 1)};
  transform: ${({ isRemoving }) => (isRemoving ? 'scale(0.9)' : 'scale(1)')};

  @media (max-width: 768px) {
    flex: 1;
    width: 100%;
  }
`;

// Styled component for the icon and line animation
const AnimatedIcon = styled.div<{ isRemoving: boolean }>`
  display: flex;
  align-items: center;
  animation: ${({ isRemoving }) => (isRemoving ? 'fadeOut' : 'fadeIn')} 0.5s ease-out;

  @keyframes fadeIn {
    0% {
      opacity: 0;
      transform: scale(0.9); /* Slightly scale down the icon */
    }
    100% {
      opacity: 1;
      transform: scale(1); /* Return to original size */
    }
  }

  @keyframes fadeOut {
    0% {
      opacity: 1;
      transform: scale(1); /* Original size */
    }
    100% {
      opacity: 0;
      transform: scale(0.9); /* Slightly scale down the icon */
    }
  }
`;

const Line = styled.div<{ color: string }>`
  width: 15px;
  height: 2px;
  background-color: ${({ color }) => color};
`;
const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 10px; 
  height: 10px; 
  border: 2px solid black; 
  border-radius: 50%; 
  padding: 7px; 
  background-color: white; 
`;

export default LegendItem;